import React from "react";
import usePluggableLicenseCheck from "hooks/usePluggableLicenseCheck";
import usePluginEntities from "hooks/usePluginEntities";
import { MarkdownPreview } from "components/common/MarkdownEditor";
const RemediationStepRenderer = ({
  eventDefinitionId,
  meta
}) => {
  var _a;
  const { context: eventsContext } = meta;
  const eventDefinitionContext = (_a = eventsContext == null ? void 0 : eventsContext.event_definitions) == null ? void 0 : _a[eventDefinitionId];
  return (eventDefinitionContext == null ? void 0 : eventDefinitionContext.remediation_steps) ? /* @__PURE__ */ React.createElement(MarkdownPreview, { show: true, withFullView: true, noBorder: true, noBackground: true, value: eventDefinitionContext.remediation_steps }) : /* @__PURE__ */ React.createElement("em", null, "No remediation steps");
};
const EventProcedureRenderer = ({ eventProcedureId, eventId }) => {
  const pluggableEventProcedureSummary = usePluginEntities("views.components.eventProcedureSummary");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, pluggableEventProcedureSummary.map(({ component: PluggableEventProcedureSummary, key }) => /* @__PURE__ */ React.createElement(PluggableEventProcedureSummary, { eventProcedureId, eventId, key })));
};
const RemediationSteps = ({ event, meta, eventDefinitionEventProcedureId }) => {
  const {
    data: { valid: validSecurityLicense }
  } = usePluggableLicenseCheck("/license/security");
  return validSecurityLicense ? /* @__PURE__ */ React.createElement(EventProcedureRenderer, { eventProcedureId: eventDefinitionEventProcedureId, eventId: event == null ? void 0 : event.id }) : /* @__PURE__ */ React.createElement(RemediationStepRenderer, { meta, eventDefinitionId: event.event_definition_id });
};
export default RemediationSteps;
